import store from "@/store/index";
import localStore from "@/utils/localStore";
import { userTypes } from "@/middleware/pageAccessManager";
import { $axios, $superAdminAxios, $superDealerAxios, $superAccountAxios } from "@/config/axios";

const nonAuthCheckingRoutes = ["emailVerify"];

export const auth = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"]) {
    next();
  } else {
    next({ path: "/sign-in" });
  }
};
export const isUnAuthenticatedUser = (to, from, next) => {
  if (nonAuthCheckingRoutes.indexOf(to) !== -1) {
    next();
  } else if (store.getters["auth/isAuthenticated"]) {
    next({ path: "/user" });
  } else {
    next();
  }
};
export const saveAccessTokenToLocalStorage = (userProfile, accessTokens) => {
  const userId = userProfile._id;
  const userType = userProfile.user_type;
  localStore.setItem("curr-user-type", userType);
  localStore.setItem(`${userType}-id`, userId);
  localStore.setItem(`${userType}-${userId}`, accessTokens);
  localStore.setItem(`${userType}-${userId}-trites`, userProfile);

  if (userType === userTypes.super_admin) {
    $superAdminAxios.defaults.headers.common.Authorization =
      accessTokens.access_token;
  } else if (userType === userTypes.dealer) {
    $superDealerAxios.defaults.headers.common.Authorization =
      accessTokens.access_token;
  } else if (userType === userTypes.account_manager) {
    $superAccountAxios.defaults.headers.common.Authorization =
    accessTokens.access_token;
  } else {
    $axios.defaults.headers.common.Authorization = accessTokens.access_token;
  }
};
export const setImpersonation = (newStatus) => {
  localStore.setItem("is-impersonation", newStatus);
};

export const setImpersonationBy = (newStatus) => {
  localStore.setItem("is-impersonation-by", newStatus);
};
export const getImpersonationBy = () => {
  return localStore.getItem("is-impersonation-by");
};

export const getImpersonation = () => {
  return localStore.getItem("is-impersonation");
};
export const clearUserLocalStorage = (userProfile) => {
  const userId = userProfile._id;
  const userType = userProfile.user_type;
  localStore.removeItem("curr-user-type");
  localStore.removeItem(`${userType}-id`);
  localStore.removeItem(`${userType}-${userId}`);
  localStore.removeItem(`${userType}-${userId}-trites`);
  if (userType === userTypes.super_admin) {
    localStore.removeItem("is-impersonation");
    localStore.removeItem("is-impersonation-by");
  } else if (userType === userTypes.dealer) {
    localStore.removeItem("is-impersonation");
    localStore.removeItem("is-impersonation-by");
  }
};

export default {
  auth,
  isUnAuthenticatedUser,
  saveAccessTokenToLocalStorage,
  clearUserLocalStorage,
};
